/**
 * Зависимости
 */
import {DEFAULT_MAP_KEY} from '../../common/scripts/constants';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

/**
 * Карта в блоке Расположение
 */
const filterListBtns = Array.from(document.querySelectorAll('.j-location-filter-list-toggle'));
const filterList = document.querySelector('.j-location-infrastructure');
const locationMap = document.querySelector('.j-location-map');
const filterCheckboxToggler = document.querySelector('.j-checkbox-toggle');
const mapFilterWrapper = document.querySelector('.j-map-filter');

let isLoaded = false;

const initLocationMap = () => {
    isLoaded = true;

    if (mapFilterWrapper) {
        import(/* webpackChunkName: "map-filter" */ '@/components/yandex-map/infrastructure-checkbox-filter')
            .then(({default: MapFilter}) => {
                const mapFilter = new MapFilter();

                mapFilter.init({target: mapFilterWrapper});

                if (filterCheckboxToggler) {
                    observer.subscribe('filterUpdated', () => {
                        filterCheckboxToggler.innerHTML = mapFilter.globalFilterState ? 'Скрыть все' : 'Показать все';
                    });

                    filterCheckboxToggler.addEventListener('click', () => {
                        mapFilter.changeCheckBoxState();
                    });
                }
            });
    }

    if (filterListBtns && filterList) {
        filterListBtns.forEach((item) => {
            item.addEventListener('click', () => {
                filterList.classList.toggle('is-open');
                document.querySelector('.yandex-map__filter').classList.toggle('is-open');
            });
        });
    }

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            import(/* webpackChunkName: "yandex-map" */ '@/components/yandex-map')
                .then(({default: YandexMap}) => {
                    const yandexMap = new YandexMap(ymaps);

                    yandexMap.init({
                        wrapper                : locationMap,
                        cluster                : true,
                        fullScreenControl      : true,
                        customFullScreenControl: true,
                        customZoomControl      : true
                    });
                });
        });
    }
};

const checkMap = () => {
    const ymaps = window.ymaps;
    const API_KEY = window?.yandexMapKey ?? DEFAULT_MAP_KEY;

    if (ymaps) {
        initLocationMap();
    } else {
        Utils.loadScript(`https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${API_KEY}`, initLocationMap);
    }
};

if (locationMap) {
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        checkMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(locationMap, window.innerHeight || document.documentElement.clientHeight)) {
            checkMap();
        } else {
            lazyImageObserver.observe(locationMap);
        }
    } else {
        checkMap();
    }
}

